import { FloatingWhatsApp } from "react-floating-whatsapp";
import { useEffect, useRef, useState } from "react";

import { configValue } from "../config";
import { normalizeWhatsAppPhoneNumber } from "../utils/whatsapp";

export default function WhatsAppChatWidget() {
  const phoneNumber = normalizeWhatsAppPhoneNumber(configValue("WHATSAPP_PHONE"));
  const [isOpen, setIsOpen] = useState(false);
  const wasOpen = useRef(false);

  useEffect(() => {
    const launcher = document.querySelector<HTMLElement>(".whatsapp-chat-launcher");
    if (!launcher) return;

    launcher.removeAttribute("aria-hidden");
    launcher.setAttribute("role", "button");
    launcher.setAttribute("tabindex", "0");
    launcher.setAttribute("aria-label", "Chat met DeVerlofkaart via WhatsApp");
    launcher.setAttribute("aria-expanded", String(isOpen));

    const panel = document.querySelector<HTMLElement>(".whatsapp-chat-panel");
    panel?.setAttribute("role", "dialog");
    panel?.setAttribute("aria-label", "WhatsApp-chat met DeVerlofkaart");
    panel?.setAttribute("aria-hidden", String(!isOpen));
    if (panel) panel.inert = !isOpen;

    const closeButton = panel?.querySelector<HTMLElement>("header > div:last-child");
    closeButton?.removeAttribute("aria-hidden");
    closeButton?.setAttribute("role", "button");
    closeButton?.setAttribute("tabindex", "0");
    closeButton?.setAttribute("aria-label", "WhatsApp-chat sluiten");

    const handleKeyDown = (event: KeyboardEvent) => {
      if (event.key !== "Enter" && event.key !== " ") return;
      event.preventDefault();
      launcher.click();
    };
    const handleCloseKeyDown = (event: KeyboardEvent) => {
      if (event.key !== "Enter" && event.key !== " ") return;
      event.preventDefault();
      closeButton?.click();
    };
    launcher.addEventListener("keydown", handleKeyDown);
    closeButton?.addEventListener("keydown", handleCloseKeyDown);

    if (isOpen) panel?.querySelector<HTMLInputElement>("input")?.focus();
    else if (wasOpen.current) launcher.focus();
    wasOpen.current = isOpen;

    return () => {
      launcher.removeEventListener("keydown", handleKeyDown);
      closeButton?.removeEventListener("keydown", handleCloseKeyDown);
    };
  }, [isOpen, phoneNumber]);

  if (!phoneNumber) return null;

  return (
    <FloatingWhatsApp
      phoneNumber={phoneNumber}
      accountName="DeVerlofkaart"
      avatar="/icons/icon-192x192.png"
      statusMessage="We reageren zo snel mogelijk"
      chatMessage={"Hallo! Hoe kunnen we je helpen?"}
      placeholder="Typ je bericht..."
      messageDelay={0}
      allowClickAway
      allowEsc
      notification={false}
      notificationSound={false}
      className="whatsapp-chat"
      buttonClassName="whatsapp-chat-launcher"
      chatboxClassName="whatsapp-chat-panel"
      chatboxHeight={318}
      onClick={() => setIsOpen(true)}
      onClose={() => setIsOpen(false)}
    />
  );
}
